module.exports = __webpack_public_path__ + "static/the-secrets-in-the-hot-sauce-cf7c1e15b2ce70fc0bacc4ba16b13d5a.jpg";